function reload() {
    const alerts = document.getElementsByTagName('cwc-alert');
    for (let i = 0;i < alerts.length; i++)
    { alerts[i].showAlert() }
}